import { HttpErrorResponse } from '@angular/common/http';
import { IContentPageResponse } from '@modeso/dgoods-lib-admin-fe/models/content.pages';
import { IContentBoxResponse, INewstickerResponse, ISpotLight } from '@modeso/types__dgoods-products';
import { Action, createAction, props } from '@ngrx/store';
import { InternationalTopUpOfferItem } from '../models/international-top-up-offer-item.interface';
import { InternationalTopUpOffersOrOperators } from '../models/international-top-up-offers-or-operators.interface';
import { InternationalTopUpPhoneContext } from '../models/international-top-up-phone-context.interface';
import { InternationalTopUpSelectedCarrier } from '../models/international-top-up-selected-carrier.interface';
import { InternationalTopUpRequestDto } from '../models/international-top-up.request.dto';
import { SelectInternationalTopUpOfferRequestDto } from '../models/select-international-top-up-offer.request.dto';
import { ShopProductsWithCategories } from '../models/shopProductsWithCategories.interface';

export const getAllProducts = createAction('[Product List] getAllProducts');

export const onAllProductsLoadedSuccessfully = createAction(
    '[Product List] all products loaded successfully',
    props<{ payload: ShopProductsWithCategories }>(),
);

export const onAllProductsLoadingFailed = createAction(
    '[Product List] all products loading failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const setActiveCategoryFilter = createAction(
    '[TDV Apply Active Category Filter] setActiveCategoryFilter',
    props<{ payload: string }>(),
);

export const setLandingPageLoadingState = createAction(
    '[TDV Set Landing Buy Loading State] setLandingPageLoadingState',
    props<{ payload: boolean }>(),
);

export const getProductById = createAction('[Product List] getProductById', props<{ productId: string }>());

export const getNewsTicker = createAction('[TDV get News Ticker] getNewsTicker request', props<{ payload: string }>());

export const onGetNewsTickerSucceeded = createAction(
    '[TDV get News Ticker] getNewsTicker success',
    props<{ payload: INewstickerResponse }>(),
);

export const onGetNewsTickerFailed = createAction(
    '[TDV get News Ticker] getNewsTicker fail',
    props<{ payload: HttpErrorResponse }>(),
);

export const getAllContentPages = createAction('[Admin Content Pages] Get All Content Pages');

export const getAllContentPagesSuccess = createAction(
    '[Admin Content Pages] Get All Content Pages Success',
    props<{ payload: IContentPageResponse[] }>(),
);

export const getAllContentPagesFailure = createAction(
    '[Admin Content Pages] Get All Content Pages Failure',
    props<{ payload: HttpErrorResponse }>(),
);

export const getSpotlights = createAction('[Get Spotlights] Get Spotlights');

export const getSpotlightsSuccessfully = createAction(
    '[Get Spotlights] Get Spotlights Successfully',
    props<{ payload: { spotlights: ISpotLight[]; userHasSpotlights: boolean } }>(),
);

export const getSpotlightsFailed = createAction(
    '[Get Spotlights] Get Spotlights Failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const markSpotlightAsRead = createAction(
    '[Mark Spotlights] Mark Spotlights As Read',
    props<{ payload: string }>(),
);

export const markSpotlightAsReadSuccessfully = createAction(
    '[Mark Spotlights] Mark Spotlights As Read Succeeded',
    props<{ payload: any }>(),
);

export const markSpotlightAsReadFailed = createAction(
    '[Mark Spotlights] Mark Spotlights As Read Failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getPublishedContentBox = createAction(
    '[Admin Content Box] Get Published Content Boxes',
    props<{ payload: string }>(),
);

export const getPublishedContentBoxSuccess = createAction(
    '[Admin Content Box] Get Published Content Boxes Success',
    props<{ payload: IContentBoxResponse }>(),
);

export const getPublishedContentBoxFailure = createAction(
    '[Admin Content Box] Get Published Content Boxes Failure',
    props<{ payload: HttpErrorResponse }>(),
);

export const lookupInternationalTopUpOffersOrOperators = createAction(
    '[International Top Up] Lookup Offers Or Operators',
    props<{ payload: InternationalTopUpRequestDto }>(),
);

export const onLookupInternationalTopUpOffersOrOperatorsSucceeded = createAction(
    '[International Top Up] Lookup Offers Or Operators Succeeded',
    props<{ payload: InternationalTopUpOffersOrOperators }>(),
);

export const onLookupInternationalTopUpOffersOrOperatorsFailed = createAction(
    '[International Top Up] Lookup Offers Or Operators Failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const setInternationalTopUpLookupLoadingState = createAction(
    '[International Top Up] Set Lookup Loading State',
    props<{ payload: boolean }>(),
);

export const setInternationalTopUpPhoneContext = createAction(
    '[International Top Up] Set Phone Context',
    props<{ payload: InternationalTopUpPhoneContext }>(),
);

export const setInternationalTopUpSelectedOffer = createAction(
    '[International Top Up] Set Selected Offer',
    props<{ payload: InternationalTopUpOfferItem }>(),
);

export const selectInternationalTopUpOffer = createAction(
    '[International Top Up] Select Offer',
    props<{ payload: SelectInternationalTopUpOfferRequestDto }>(),
);

export const onSelectInternationalTopUpOfferSucceeded = createAction('[International Top Up] Select Offer Succeeded');

export const onSelectInternationalTopUpOfferFailed = createAction(
    '[International Top Up] Select Offer Failed',
    props<{ payload: HttpErrorResponse }>(),
);

export const setInternationalTopUpSelectedCarrier = createAction(
    '[International Top Up] Set Selected Carrier',
    props<{ payload: InternationalTopUpSelectedCarrier }>(),
);

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
